import HomeCleaningIcon from "@/assets/images/3d-icons/home-cleaning.png";
import AirconServiceIcon from "@/assets/images/3d-icons/aircon.png";
import MattressIcon from "@/assets/images/3d-icons/mattress-cleaning.png";
import ManiPediIcon from "@/assets/images/3d-icons/home-beauty.png";
import SofaIcon from "@/assets/images/3d-icons/sofa.png";
import CarpetIcon from "@/assets/images/3d-icons/rug.png";
import CurtainIcon from "@/assets/images/3d-icons/curtain.png";
import HomeMassageIcon from "@/assets/images/3d-icons/home-massage.png";
import PetGroomingIcon from "@/assets/images/3d-icons/pet-grooming.png";
import MedicalEscordIcon from "@/assets/images/3d-icons/medical-escort.png";
import LashesIcon from "@/assets/images/3d-icons/lashes.png";
import HandymanIcon from "@/assets/images/3d-icons/handyman.png";
import PlumbingIcon from "@/assets/images/3d-icons/plumbing.png";
import BabysittingIcon from "@/assets/images/3d-icons/babysitter.png";
import EldercareIcon from "@/assets/images/3d-icons/eldercare.png";
import ElectricianIcon from "@/assets/images/3d-icons/electrician.png";
import FloorPolishingIcon from "@/assets/images/3d-icons/floor-polishing.png";
import PetSittingIcon from "@/assets/images/3d-icons/pet-sitting.png";
// import PramIcon from "@/assets/images/3d-icons/pram.png";
// import FacialIcon from "@/assets/images/3d-icons/facial.png";
import PestIcon from "@/assets/images/3d-icons/pest-cotrol.png";
// import ConfinementNannyIcon from "@/assets/images/3d-icons/confinement-nanny.png";
import DeepCleaningIcon from "@/assets/images/3d-icons/deep-cleaning.png";
import type {
  PackageRecurrenceEnum,
  ServiceTypeEnum,
} from "@/__generated__/graphql";
import { app } from "@/config/env";
import { PosthogAnalytics } from "@/lib/monitoring/posthog";

export type SearchServiceType = "service-detail" | "landing-page";

export type SearServiceDetailFilter = {
  serviceTypes: ServiceTypeEnum[];
  repeatEvery: PackageRecurrenceEnum[];
  repeatEveryTimes: number;
};

export type SearchServiceItem = {
  title: string;
  url: string;
  type: SearchServiceType;
  icon: string;
  synonyms: string[];
};

export function searchServiceItems(): SearchServiceItem[] {
  const { distinct_id, session_id } = PosthogAnalytics.getIdentifiers();
  const landingPageDomain = app.LANDING_PAGE_DOMAIN;
  let posthogUserTrackingQuery = "";
  if (distinct_id && session_id) {
    posthogUserTrackingQuery = `?distinct_id=${distinct_id}&session_id=${session_id}`;
  }
  return [
    {
      title: "Home Cleaning",
      url: "/service-detail/home-cleaning",
      type: "service-detail",
      icon: HomeCleaningIcon,
      synonyms: [
        "home",
        "cleaning",
        "house",
        "clean",
        "domestic",
        "home cleaning",
      ],
    },
    {
      title: "Home Beauty",
      url: "/service-detail/home-beauty",
      type: "service-detail",
      icon: ManiPediIcon,
      synonyms: [
        "home",
        "beauty",
        "nail",
        "manicure",
        "pedicure",
        "home beauty",
      ],
    },
    {
      title: "Eyelash",
      url: "/service-detail/lashes",
      type: "service-detail",
      icon: LashesIcon,
      synonyms: [
        "eyelash",
        "lashes",
        "lash",
        "extension",
        "eyelashes",
        "eyelash extension",
      ],
    },
    // {
    //   title: "Pram Seat",
    //   url: "/service-detail/pram-seat",
    //   type: "service-detail",
    //   icon: PramIcon,
    //   synonyms: ["pram", "seat", "car", "stroller", "baby", "pram seat"],
    // },
    {
      title: "Rug Cleaning",
      url: "/service-detail/rug-cleaning",
      type: "service-detail",
      icon: CarpetIcon,
      synonyms: [
        "rug",
        "cleaning",
        "carpet",
        "floor",
        "mat",
        "rug cleaning",
        "carpet cleaning",
      ],
    },
    {
      title: "Curtain Cleaning",
      url: "/service-detail/curtain-cleaning",
      type: "service-detail",
      icon: CurtainIcon,
      synonyms: [
        "curtain",
        "cleaning",
        "drape",
        "blinds",
        "window",
        "curtain cleaning",
      ],
    },
    {
      title: "Sofa Cleaning",
      url: "/service-detail/sofa-cleaning",
      type: "service-detail",
      icon: SofaIcon,
      synonyms: [
        "sofa",
        "cleaning",
        "couch",
        "upholstery",
        "furniture",
        "sofa cleaning",
      ],
    },
    {
      title: "Mattress Cleaning",
      url: "/service-detail/mattress-cleaning",
      type: "service-detail",
      icon: MattressIcon,
      synonyms: [
        "mattress",
        "cleaning",
        "bed",
        "sleep",
        "mattresses",
        "mattress cleaning",
      ],
    },
    {
      title: "Massage Service",
      url: "/service-detail/home-massage",
      type: "service-detail",
      icon: HomeMassageIcon,
      synonyms: [
        "massage",
        "service",
        "therapy",
        "relaxation",
        "spa",
        "massage service",
      ],
    },
    {
      title: "Aircon Services",
      url: "/service-detail/aircon",
      type: "service-detail",
      icon: AirconServiceIcon,
      synonyms: [
        "aircon",
        "services",
        "air",
        "conditioning",
        "ac",
        "aircon services",
      ],
    },
    {
      title: "Handyman",
      url: `${landingPageDomain}/services/handyman${posthogUserTrackingQuery}`,
      type: "landing-page",
      icon: HandymanIcon,
      synonyms: ["handyman", "repair", "fix", "maintenance", "handy"],
    },
    {
      title: "Plumbing",
      url: `${landingPageDomain}/services/plumbing${posthogUserTrackingQuery}`,
      type: "landing-page",
      icon: PlumbingIcon,
      synonyms: ["plumbing", "plumber", "pipe", "water", "drain"],
    },
    {
      title: "Electrician",
      url: `${landingPageDomain}/services/electrician${posthogUserTrackingQuery}`,
      type: "landing-page",
      icon: ElectricianIcon,
      synonyms: ["electrician", "electrical", "wiring", "power", "electric"],
    },
    {
      title: "Pet Grooming",
      url: "/service-detail/pet-grooming",
      type: "service-detail",
      icon: PetGroomingIcon,
      synonyms: ["pet", "grooming", "dog", "cat", "animal", "pet grooming"],
    },
    {
      title: "Pet Sitting",
      url: "/service-detail/pet-sitting",
      type: "landing-page",
      icon: PetSittingIcon,
      synonyms: [
        "pet",
        "sitting",
        "care",
        "dog",
        "cat",
        "animal",
        "pet sitting",
      ],
    },
    {
      title: "Babysitter",
      url: `${landingPageDomain}/services/babysitter${posthogUserTrackingQuery}`,
      type: "landing-page",
      icon: BabysittingIcon,
      synonyms: ["babysitter", "baby", "sitter", "childcare", "nanny"],
    },
    {
      title: "Eldercare",
      url: "/service-detail/elder-care",
      type: "service-detail",
      icon: EldercareIcon,
      synonyms: ["eldercare", "elder", "care", "senior", "aged"],
    },
    {
      title: "Medical Escort",
      url: `${landingPageDomain}/services/medical-escort${posthogUserTrackingQuery}`,
      type: "landing-page",
      icon: MedicalEscordIcon,
      synonyms: [
        "medical",
        "escort",
        "hospital",
        "doctor",
        "health",
        "medical escort",
      ],
    },
    {
      title: "Floor Polishing",
      url: `${landingPageDomain}/services/floor-polishing${posthogUserTrackingQuery}`,
      type: "landing-page",
      icon: FloorPolishingIcon,
      synonyms: [
        "floor",
        "polishing",
        "wax",
        "shine",
        "tiles",
        "vinyl",
        "marble",
        "floor polishing",
      ],
    },
    {
      title: "Pest Control",
      url: `${landingPageDomain}/services/pest-control${posthogUserTrackingQuery}`,
      type: "landing-page",
      icon: PestIcon,
      synonyms: [
        "pest",
        "control",
        "pest control",
        "exterminator",
        "insect",
        "bug",
      ],
    },
    {
      title: "Deep Cleaning",
      url: "/service-detail/deep-cleaning",
      type: "service-detail",
      icon: DeepCleaningIcon,
      synonyms: [
        "deep",
        "cleaning",
        "deep cleaning",
        "thorough",
        "intensive",
        "detailed",
      ],
    },
  ];
}
